export const uk = {
    'image-download-error': 'При загрузке изображения произошла ошибка. Повторите позже.',
    'request-error': 'Произошла непредвиденная ошибка.'
};
